export type VendorMetadata =
  | Record<string, Array<{ type: string; value: string }>>
  | undefined;

export type VendorMetadataEntry = { vendor: string; value: string };

export function vendorEntriesByType(
  vendorMetadata: VendorMetadata,
  metadataType: string
): VendorMetadataEntry[] {
  if (!vendorMetadata) {
    return [];
  }

  const entries: VendorMetadataEntry[] = [];

  for (const [vendor, metadataEntries] of Object.entries(vendorMetadata)) {
    for (const entry of metadataEntries) {
      if (entry.type === metadataType) {
        entries.push({ vendor, value: entry.value });
      }
    }
  }

  return entries;
}
